import Decimal from 'decimal.js';

/**
 * Clamp helper.
 */
export const capAmount = ({
  amount,
  min,
  max,
}: {
  amount: number;
  min: number;
  max: number;
}): number => Math.min(Math.max(amount, min), max);

/**
 * Calculate payout
 */
export const calculatePayout = ({
  betAmount,
  multiplier,
  withRoundedMultiplier,
}: {
  betAmount: Decimal;
  multiplier: Decimal;
  withRoundedMultiplier?: boolean;
}): {
  roundedMultiplier: Decimal;
  payout: Decimal;
  profit: Decimal;
} => {
  const roundedMultiplier = withRoundedMultiplier
    ? new Decimal(multiplier).toDecimalPlaces(2, Decimal.ROUND_DOWN)
    : multiplier;
  const betDecimal = new Decimal(betAmount);
  const payout = betDecimal.mul(roundedMultiplier);
  const profit = payout.sub(betDecimal);
  return { roundedMultiplier, payout, profit };
};
